const SHIPMENT_GROUP_CODE = 'SHIPMENT'
const SHIPHERO_PLATFORM_CODE = 'SHIPHERO'

/** Same source-store code resolution the settings page already uses. */
export const getSettingsSourcePlatformCode = (sourceStore: any): string =>
  `${sourceStore?.code ?? sourceStore?.name ?? sourceStore?.platform_info?.name ?? ''}`
    .trim()
    .toUpperCase()

type UploadFieldMapping = {
  isDefault?: boolean
  [key: string]: any
}

export const isOneToOneDependentMapping = (
  fieldMapping: UploadFieldMapping | null | undefined,
  mappedPartner: unknown
): boolean => fieldMapping?.isDefault === false && mappedPartner != null && mappedPartner !== false

/**
 * Upload shows only when the section source store is ShipHero,
 * the row is a 1-to-1 dependent mapping, and the section group is SHIPMENT.
 * Destination platform is not part of this check.
 */
export const shouldShowShippingMethodUploadButton = ({
  groupCode,
  sourceStore,
  fieldMapping,
  mappedPartner,
}: {
  groupCode?: string | null
  sourceStore?: any
  fieldMapping?: UploadFieldMapping | null
  mappedPartner?: unknown
}): boolean => {
  if (`${groupCode ?? ''}`.trim().toUpperCase() !== SHIPMENT_GROUP_CODE) return false
  if (getSettingsSourcePlatformCode(sourceStore) !== SHIPHERO_PLATFORM_CODE) return false
  return isOneToOneDependentMapping(fieldMapping, mappedPartner)
}
